var map = {
	"./gray-all.svg": 30935,
	"./gray-date.svg": 75190,
	"./gray-done.svg": 25842,
	"./gray-dotted-circle.svg": 47083,
	"./gray-patient.svg": 85533,
	"./gray-sun.svg": 31656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15972;